var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProductError = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 58,
  height: 58,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29 57.875a3.93 3.93 0 0 0 2.769-1.128l24.977-24.973c1.505-1.52 1.505-4.017 0-5.536L31.77 1.265a3.933 3.933 0 0 0-5.538 0L1.254 26.238c-1.505 1.504-1.505 4.016 0 5.536L26.23 56.747A3.93 3.93 0 0 0 29 57.875Zm-.03-3.851L3.977 29.036c-.03-.03-.03-.045 0-.076L28.97 3.988c.03-.03.045-.03.075 0L54.008 28.96c.045.045.06.045.015.075L29.045 54.009c-.045.045-.045.06-.075.015Z",
  fill: "#111",
  fillOpacity: 0.48
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.563 26.938h4.124v4.125h-4.125v-4.125ZM26.938 26.938h4.125v4.125h-4.125v-4.125ZM39.313 26.938h4.124v4.125h-4.124v-4.125Z",
  fill: "#111",
  fillOpacity: 0.48
})));
export default SvgProductError;